import React, { FC } from "react";
import { TierEditor } from "./TierEditor";
import { usePricing } from "./PricingContext";
import { DotLottleLoader } from "../../../components/Loader";

export const ProjectCountTiers: FC = () => {
    const { data, loading } = usePricing();
    if (loading || !data) return <DotLottleLoader />;
    return (
        <TierEditor
            title="Project Count Tiers"
            resource="project-count-tiers"
            minField="min_projects"
            minLabel="Min Projects"
            rows={data.project_count_tiers}
        />
    );
};

export default ProjectCountTiers;
